module.exports = __webpack_public_path__ + "img/976.f7a60650.png";